import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Typography, Box } from '@material-ui/core';
import { ROUTES } from '../../router/routes';

import Button from '../../../components/form/elements/Button';
import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT } from '../../../components/form/enum/formProps';
import './../Error.scss';

const Unavailable = () => {
  const { t } = useTranslation();

  return (
    <Container className="Error-Container">
      <Typography variant="h3">{t('error.503.title')}</Typography>
      <Typography variant="h4">{t('error.503.content')}</Typography>
      <Box display="flex" justifyContent="center">
        <a href={ROUTES.FARMAPROM}>
          <Button
            color={BUTTON_COLOR.SECONDARY}
            type={BUTTON_TYPE.BUTTON}
            size={BUTTON_SIZE.LARGE}
            variant={BUTTON_VARIANT.CONTAINED}
            text="auth.farmaprom"
          />
        </a>
      </Box>
    </Container>
  );
};

export default Unavailable;
